<div class="row">
  <div class="fulfillmentLanding create-return-outer" (window:resize)="onresize($event)">
    <div class="create-return-page">
      <div class="page-head xs-mt-15">
        <h3 *ngIf="!isReturnTypeForInnoculant" class="d-flex align-items-center">CPP Returns</h3>
        <h3 *ngIf="isReturnTypeForInnoculant" class="d-flex align-items-center">Inoculant Returns</h3>
        <p>Filter return request by choosing the type of the filter you'd like to use and searching for a value. You may opt to view submitted returns on the tab below, or see your saved drafts by selecting return request drafts tab.</p>
      </div>
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a *ngIf="!isReturnTypeForInnoculant" href="javascript:void(0)" routerLink="/cpp-returns/dashboard-products">CPP Returns</a>
              <a *ngIf="isReturnTypeForInnoculant" href="javascript:void(0)" routerLink="/cpp-returns/dashboard-products/Inoculant">CPP Returns</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item active">
              <a *ngIf="!isReturnTypeForInnoculant" href="javascript:void(0)" routerLink="/cpp-returns/dashboard-products">Product Returns</a>
              <a *ngIf="isReturnTypeForInnoculant" href="javascript:void(0)" routerLink="/cpp-returns/dashboard-products/Inoculant">Inoculant Returns</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>

      <div class="returnTop xs-mb-5">
        <div *ngIf="createRequestAccess">
          <div class="row">

            <!--Sold To Select List-->
            <div class=" col-md-6 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
              <ng-select name="ddlSoldTo"
                         [items]="soldToFacility"
                         class="custom-select-grower grower-add-drop"
                         [class.ng-select-disabled]="!soldToAccount"
                         [virtualScroll]="true"
                         [(ngModel)]="soldToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="true"
                         bindValue="accountNumber"
                         placeholder="Sold To: (Will Display after selection of Ship To):"
                         [loading]="soldToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         data-testid="ddl-sold-to">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template" [attr.data-testid]="'ddl-sold-to-option_'+item.accountNumber">
                    <div class="row">
                      <div class="col-md-12  mb-2">
                        <div class="mb-0 mt-2" [attr.data-testid]="'ddl-sold-to-option-account-name_'+item.accountNumber">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="border-line pb-2" [attr.data-testid]="'ddl-sold-to-option-account-number'+item.accountNumber">
                          Account To #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template" [attr.data-testid]="'ddl-sold-to-list-option_'+item.accountNumber">
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <div class="name mb-0">
                          {{item.accountName}}
                        </div>
                        <div class="address  mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="phoneNo mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="grower-nos mb-2">
                          <span class="grower-gln">
                            Account To #: {{item.accountNumber}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div class=" col-lg-6 col-md-6 material-select withBordr required">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop cpp-return-shipto"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="isEditMode || readOnlyAccess"
                         bindValue="accountNumber"
                         placeholder="Ship To:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)"
                         data-testid="ddl-ship-to-search">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12 mb-2">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="border-line pb-2">
                          Account To #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template" [attr.data-testid]="'ddl-ship-to-option_'+item.accountNumber">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div class="col-lg-3 col-md-6 required-input-field" hidden>
              <mat-form-field class="wide100">
                <mat-label>DSM :</mat-label>
                <input [disabled]="isEditMode || readOnlyAccess || showSubmitToJde" readonly matInput type=text name="dsm"
                       autocomplete="new-username"
                       [(ngModel)]="dsmInfo"
                       value="dsmInfo" />
              </mat-form-field>
            </div>
            <div class=" col-lg-3 col-md-6 material-select withBordr" hidden>
              <ng-select name="ddlOnBahlfOf"
                         [items]="requestOnBehalfList"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="onBehalfUser"
                         bindLabel="userName"
                         [disabled]="readOnlyAccess || showSubmitToJde"
                         placeholder="Request on Behalf of:"
                         bindValue="userId"
                         (change)="setUserEmail($event)"
                         [closeOnSelect]="true">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.userName}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-lg-3 col-md-6 required-input-field" hidden>
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <mat-label>Email:</mat-label>
                <input matInput type="email" name="accountEmail"
                       [(ngModel)]="accountEmail"
                       [readonly]="readOnlyAccess"
                       [disabled]="showSubmitToJde"
                       [pattern]="emailPattern"
                       (keyup)="validateEmail()"
                       (input)="hasEmailAddressChanged();"
                       email="true">
                <mat-error *ngIf="isNotValid">
                  Email not valid.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!--Pickup Information Section-->
      <div class="returnTop xs-pb-0 applyBoxShadow">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0">
          Pickup Information: <span class="verbiage xs-ml-5 flex-one">(*Required)</span> <span (click)="togglePickup()" class="xs-expand-none xs-mr-20"
                                                                                               [ngClass]="!isAddProductEnable ? 'disabled-icon' : ' '">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
        <div class="row" [@detailExpand]="isExpanded ? 'collapsed' : 'expanded'">
          <div class="col-lg-2 col-md-6">
            <div class="text-center deliveryDatePicker required-input-field">
              <mat-form-field>
                <mat-label>Desired Pickup Date</mat-label>
                <input matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter" [(ngModel)]="desiredPickupDate" [min]="minDate" #dateName="ngModel"
                       name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');" [disabled]="showSubmitToJde"
                       required (change)="desiredPickupDateValid(dateName)" (dateChange)="ValidateSelectedDesiredPickupDate($event)" data-testid="txt-pickup-date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker [dateClass]="dateClass()" #picker (opened)="onOpen()">
                  <div #datepickerFooter>
                    <div class="row border-top m-0">
                      <div class="col-sm-5 col-5 pr-0">
                        <div class="p-1 ">
                          <span class="white-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Today's Date
                          </span>
                        </div>
                        <div class="p-1">
                          <span class="green-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Requested Delivery
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-7 col-7">
                        <div class="p-1">
                          <span class="yellow-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Scheduled Delivery Dates
                          </span>
                        </div>
                        <div class="p-1">
                          <span class="grey-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            UnScheduled Delivery Dates
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 ">
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Contact Name :</mat-label>
                <input matInput type=text name="Contact Name"
                       autocomplete="new-username"
                       [(ngModel)]="contactName"
                       maxlength="15"
                       required
                       #name="ngModel"
                       (change)="nameShouldBeValid(name)"
                       [disabled]="showSubmitToJde"
                       data-testid="txt-contact-name"/>
              </mat-form-field>
            </div>
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Contact Number :</mat-label>
                <input matInput type=text name="Contact Number"
                       autocomplete="new-username"
                       [(ngModel)]="contactNumber"
                       required
                       mask="000-000-0000"
                       #phone="ngModel"
                       (change)="phoneShouldBeValid(phone)"
                       [disabled]="showSubmitToJde"
                       data-testid="txt-contact-number"/>
                <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
            <div class="not-required-input">
              <mat-form-field class="wide100">
                <mat-label>Customer PO Number :</mat-label>
                <input matInput type=text name="Customer PO Number"
                       autocomplete="new-username"
                       [(ngModel)]="customerPONumber"
                       maxlength="25"
                       (input)="enablePlaceOrderAndSaveOrderDraft();"
                       data-testid="txt-customerpo" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 material-select withBordr not-required-select" [class.cpp-create-soldTo]="!deliverToAnotherLocation">
            <ng-select name="ddlDeliveryAccount"
                       [items]="deliveryAccountList"
                       class="custom-select-grower  grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="deliveryAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="!deliverToAnotherLocation"
                       placeholder="Pickup Location:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getDefaultDeliveryDate($event)"
                       (clear)="getDefaultDeliveryDate($event)"
                       data-testid="ddl-deliver-to-search">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-deliver-to-option_'+item.accountNumber">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div>
              <mat-checkbox class="custom-checkbox pr-2"
                            [disabled]="readOnlyAccess"
                            [style.display]=""
                            [checked]=""
                            [indeterminate]=""
                            (change)="UpdateDeliverToSelection($event.checked)"
                            [(ngModel)]="deliverToAnotherLocation"
                            data-testid="ddl-deliverto-checkbox-return"></mat-checkbox>
              <label class="checkbox-color">If Pickup Location is different than Ship To.</label>
            </div>
            <div>
              <label for="specialInst" class="checkbox-color mb-0">Shipping Instructions:</label>
              <mat-form-field class="example-full-width specialInst mt-0" floatLabel="never">
                <textarea style="resize:none;height:auto;" matInput rows="6"
                          [(ngModel)]="shippingInstructions"
                          appearance="fill"
                          [maxLength]="500"
                          [readonly]="readOnlyAccess"
                          placeholder="up to 500 characters"
                          [disabled]="showSubmitToJde"
                          data-testid="ddl-shipping-instructions"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-lg-4 col-md-6 material-select withBordr">
            <div class="freight-dd">
              <label>Freight Instructions:</label>
              <div class="dd-scroll">
                <mat-selection-list #freightInstructionCtrl [(ngModel)]="selectedFreightInstructionOptions">
                  <mat-list-option *ngFor="let item of freightInstruction;let index=index" [value]="item">
                    <span [attr.data-testid]="'ddl-freightins-option_'+index">{{item.value}}</span>
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
            <div class="row no-gutter">
              <div class="col-md-4 xs-pl-15 required-input-field">
                <mat-form-field class="wide100">
                  <mat-label>Pallet Count :</mat-label>
                  <input matInput type="text" name="Pallet Count"
                         autocomplete="new-username"
                         [(ngModel)]="palletCount"
                         required
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count="ngModel"
                         [disabled]="showSubmitToJde"
                         (change)="countShouldBeValid(count)"
                         data-testid="ddl-pallet-count"/>
                  <!--<mat-error *ngIf="count.invalid && (count.dirty || count.touched)">Please enter the number of pallets being returned</mat-error>-->
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="addProdContent">

          <div class="grower-add-sec seed-return-filter">
            <div *ngIf="!readOnlyAccess" class="row listing-action-items grower-page">
              <div class="col-lg-8 col-md-9">
                <mat-checkbox *ngIf="isAddProductEnable" #AllProductCheck class="custom-checkbox select-all-check"
                              [checked]="isAllProductChecked"
                              [style.display]="disablecheckbox ? 'none' : 'block'"
                              [indeterminate]="checkBoxCount > 0 && !isAllProductChecked"
                              (change)="enableAllCheckBoxes(!isAllProductChecked)"
                              title="Select All Lines"
                              data-testid="chk-select-all-product"></mat-checkbox>
                <div class="product-filter-outer">
                  <div class="product-filter col-md-12" *ngIf="!editToolKit || checkBoxCount<=0 || isSearchClicked">
                    <div class="search-category">
                      <div class="brand-dropdown default-select">
                        <ng-select [disabled]="readOnlyAccess" [items]="searchTypeList"
                                   name="ddlProductSearch"
                                   [(ngModel)]="productSearchFilter"
                                   [virtualScroll]="true"
                                   [closeOnSelect]="true"
                                   [selectOnTab]="true"
                                   [clearable]="false"
                                   bindLabel="name"
                                   bindValue="value"
                                   [searchable]="false"
                                   (change)="keepFilter()"
                                   placeholder="Select Category"
                                   data-testid="ddl-searchreturncategory">
                          <ng-option *ngFor="let data of reasonList;let index=index" [value]="data.id">
                            <span [attr.data-testid]="'ddl-searchreturncategory-option_'+index">{{data.value}}</span>
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                    <div class="search-box">
                      <div class="row margin-0">
                        <div class="default-select select-container">

                          <div class="padding-t5" *ngIf="productSearchFilter === 'productName'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectProductName($event)" [(ngModel)]="productFilters.productName" placeholder="Search...">
                              </div>
                            </div>
                          </div>

                          <!--Package Size Search box-->
                          <div *ngIf="productSearchFilter === 'packageSize'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectPackageSize($event)" [(ngModel)]="productFilters.packageSize" placeholder="Search...">
                              </div>
                            </div>
                          </div>

                          <!--<ng-select #packageSize name="ddlpackageSizeSearch" *ngIf="productSearchFilter === 'packageSize'"
                                     [items]="packageSizeMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.packageSize"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>-->
                          <div *ngIf="productSearchFilter === 'vendorName'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectVendorName($event)" [(ngModel)]="productFilters.vendorName" placeholder="Search...">
                              </div>
                            </div>
                          </div>

                          <div *ngIf="productSearchFilter === 'productLine'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectProductLine($event)" [(ngModel)]="productFilters.productLine" placeholder="Search...">
                              </div>
                            </div>
                          </div>

                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'itemNumber'"
                                     [items]="invoicedProductList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.invoicedProductList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()"
                                     data-testid="ddl-prod-search">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template" [attr.data-testid]="'ddl-prod-search-option_'+index">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'invoiceNumber'"
                                     [items]="invoiceNumberList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.invoiceNumberList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'lotNumber'"
                                     [items]="lotNumberList"
                                     placeholder="Search"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     class="custom-select-grower"
                                     [(ngModel)]="productFilters.lotNumberList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-select #statusSearch name="ddlStatusSearch" *ngIf="productSearchFilter === 'status'"
                                     [items]="statusList"
                                     placeholder="Search"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     class="custom-select-grower"
                                     [(ngModel)]="productFilters.status"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row chips-sec" *ngIf="(!editToolKit || checkBoxCount<=0 || isSearchClicked) && filterValueList != ''">
                    <div class="col-sm-9 col-md-10 selected-chip">
                      <div>
                        <mat-chip-set>
                          <mat-chip selected *ngFor="let filterValue of filterValueList">
                            {{filterValue}}
                            <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                              <i class="fas fa-times text-right"></i>
                            </a>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>
                    <div class="col-sm-3 col-md-2 text-right">

                      <a href="Javascript:void(0);" *ngIf="filterValueList.length > 0" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                    </div>
                  </div>
                </div>

                <div class="product-tools-tab" *ngIf="showTabs && (!isSearchClicked && editToolKit)" appClickOutside (clickOutside)="tabNode=''">
                  <div class="tab-bar">
                    <ul>
                      <li *ngIf="(isValidLineStatus && !readOnlyAccess)" (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Products" [matTooltipPosition]="'above'">
                        <i class="icon-ico-trash"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div *ngIf="tabNode==='delete'" class="delete-product">
                      <div class="tab-content-heading">
                        For: {{selectedAccountName}}
                      </div>
                      <div class="tab-content-detail">
                        <p>Are you sure you want to delete <span> {{checkBoxCount}} </span> selected Items(s)?</p>
                        <div class="btn-area">
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-3 text-right">
                <div class="row">
                  <div class="col-md-2 text-left padding-l0">
                    <ul class="padding-t10">
                      <li *ngIf="checkBoxCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                        <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-10 text-center">
                    <button mat-raised-button class="btns" [disabled]="!isAddProductEnable" data-testid="btn-addproductreturn" *ngIf="(!readOnlyAccess)" (click)="addProduct()">Add Product</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 margin-t10">
              <div class="productTableOuter">
                <div class="tableContainer prodTableContainer" id="returnRequestView">
                  <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'">
                      <th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                </div>
                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
                <div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Item Number</th></div>
                <div *ngIf="column=='eligibleUnits'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
                <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
                <div *ngIf="column=='dumpedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Requested Units</th></div>
                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Package Size</th></div>
                <div *ngIf="column=='notes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
                <div *ngIf="column=='approverNotes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Approver Notes</th></div>
                <td mat-cell *matCellDef="let element; let i = dataIndex">
                  <div *ngIf="column=='checkbox'">
                    <div *ngIf="requestStatus!='DRAFT'" [ngClass]="{ 'lineitem-error': element.lineStatus =='ERROR'}" class="lineitem-symbols"></div>
                  </div>
                  <div *ngIf="column=='checkbox' && !readOnlyAccess && isAddProductEnable" class="text-center CheckBoxCol" matTooltip="Select Product" [matTooltipPosition]="'above'">

                    <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck._checked); element.isSelected=SingleCheck._checked;"
                                  [(ngModel)]="element.isSelected"
                                  class="custom-checkbox" [disabled]="isReturnTypeForInnoculant && element.approvedBy && !element.isShowInoculantWarning && !element.isReturnToDraft"
                                  [attr.data-testid]="'chk-specific-check_'+element.itemNumber"></mat-checkbox>
                  </div>
                  <div *ngIf="column=='product'" class="order-info-outer"
                       [disabled]="isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft">
                    <div class="order-info">
                      <p class="prod-id" [attr.data-testid]="'lbl-vendor-name_'+element.itemNumber">{{element.itemVendorName}}</p>
                      <p class="prod-name" [attr.data-testid]="'lbl-description_'+element.itemNumber">{{element.itemDescription}}</p>
                    </div>
                  </div>
                  <div *ngIf="column=='itemNumber'" class="measureUnit text-center"
                       [disabled]="isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft">
                    <p [attr.data-testid]="'lbl-item-number_'+element.itemNumber"> {{element.itemNumber}} </p>
                  </div>
                  <div *ngIf="column=='eligibleUnits'" class="measureUnit text-center"
                       [disabled]="isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft">
                    <p *ngIf="element.isManualLine" class="handCursor greyBg" matTooltipClass="toolTip" matTooltip="This is a manually added item." [matTooltipPosition]="'above'" [attr.data-testid]="'lbl-eligible-units_'+element.itemNumber"> N/A </p>
                    <p *ngIf="!element.isManualLine" [attr.data-testid]="'lbl-eligible-units_'+element.itemNumber"> {{element.eligibleUnit}} </p>
                  </div>
                  <div *ngIf="column=='dumpedUnits'" class="quantityBlock text-center"
                       [disabled]="isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft">
                    <div>
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isDecreaseQtyDisable || (isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft)" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element)" [attr.data-testid]="'btn-specific-minus_'+element.itemNumber"> - </button>
                      <input [readonly]="readOnlyAccess" [disabled]="element.isDecreaseQtyDisable || element.isIncreaseQtyDisable || (isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft)" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.returnQuantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" [attr.data-testid]="'txt-specific-qty_'+element.itemNumber" />
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isIncreaseQtyDisable || (isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft)" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element)" [attr.data-testid]="'btn-specific-plus_'+element.itemNumber"> + </button>
                    </div>
                  </div>
                  <div *ngIf="column=='uom'" class="measureUnit text-center">
                    <p [attr.data-testid]="'lbl-order-uom_'+element.itemNumber"> {{element.uom}} </p>
                  </div>
                  <div *ngIf="column=='packageSize'" class="measureUnit text-center">
                    <p [attr.data-testid]="'lbl-package-size_'+element.itemNumber"> {{element.packageSize}} </p>
                  </div>
                  <div *ngIf="column=='notes'" class="measureUnit text-center">
                    <textarea *ngIf="showSubmitToJde == false" [readonly]="readOnlyAccess" [disabled]="isReturnTypeForInnoculant && element.approverNotes && element.approverNotes != '' && !element.isShowInoculantWarning && !element.isReturnToDraft" type="text" class="notesTxt" [attr.data-testid]="'txt-custnotes_'+element.itemNumber" [(ngModel)]="element.customerNotes" maxlength="250" (input)="hasNotesChanged(element.customerNotes);"></textarea>
                    <p *ngIf="showSubmitToJde == true" [attr.data-testid]="'txt-custnotes_'+element.itemNumber"> {{element.customerNotes}} </p>
                  </div>
                  <div *ngIf="column=='approverNotes'" class="measureUnit text-center">
                    <textarea *ngIf="showSubmitToJde == false" id="txtRequestorNotes_{{element.itemNumber}}" disabled="disabled" [readonly]="readOnlyAccess" type="text" class="notesTxt" [(ngModel)]="element.approverNotes" maxlength="250" [attr.data-testid]="'txt-approver-notes_'+element.itemNumber"></textarea>
                    <p *ngIf="showSubmitToJde == true" [attr.data-testid]="'txt-approver-notes_'+element.itemNumber"> {{element.approverNotes}} </p>
                  </div>
                </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}">
                      <div class="row">
                        <div class="col-md-9">
                          <ol class="error-list">
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="warningDetail">
                  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error-warning" *ngIf="isReturnTypeForInnoculant && element.isIPConfigured == true && element.isShowInoculantWarning" id="warning_{{element.itemId}}_{{element.lotNumber}}">
                      <div class="row">
                        <div class="col-md-9">
                          <ol class="margin-b0">
                            <li>
                              {{warningMessage}}
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    [ngStyle]="(isReturnTypeForInnoculant && element.approvedBy && !element.isShowInoculantWarning && !element.isReturnToDraft) && {'background-color': 'lightgrey'}"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                <tr mat-row *matRowDef="let row; columns: ['warningDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Error section on table-->
    <div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
      <div class="row">
        <div class="col-md-2 padding-r0 errCountOuter">
          <span class="errorCounting">
            {{currentErrorRow}} of {{errorMsgs.length}}
          </span>
        </div>
        <div class="col-md-6 padding-l0 ">
          <ul class="errorMsg">
            <li *ngFor="let err of errorMsgs[index].errors">
              <p> {{err.error}}</p>
            </li>
          </ul>
        </div>
        <div class="col-md-4 button-sec text-right">
          <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
        </div>
      </div>
    </div>
    <div class="SeedFulfillBtnSec">
      <div class="row padding-l20">
        <div class="col-md-6">
          <button mat-raised-button class="btns" *ngIf="!readOnlyAccess && showSubmitReturn" data-testid="btn-reviewretrequest" [disabled]="isDisableSubmitRequestBtn()" (click)="saveDraft(true)" [style.display]="'inline-block' ">Review Request</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="!readOnlyAccess && showSubmitReturn" data-testid="btn-saveretrequestdraft" [disabled]="isDisableSaveDraftBtn()" (click)="saveDraft(false)" [style.display]="'inline-block'">Save Draft</button>
        </div>
        <div class="col-md-6 text-right" *ngIf="chatAccess">
          <span class="count" style="margin-right: 50px;">Returnable Products <span style="margin-right: 20px;">{{selectedCount}}</span></span>
        </div>
        <div class="col-md-6 text-right" *ngIf="!chatAccess">
          <span class="count">Returnable Products <span>{{selectedCount}}</span></span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
